import { useRef } from "react";
// import fetch from "auth/FetchInterceptor";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import {
  FacebookShare,
  LinkedinShare,
  TwitterShare,
} from "component/SocialMediaComponent/SocialMediaComponent";
import HtmlView from "component/htmlView/html-view";
import { API_BASE_URL } from "configs/AppConfig";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import { DateFormater } from "functions/dateTimeFormat";
import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import NewsCustomizedContentWrapper from "../newsCustomizedContentWrapper/NewsCustomizedContentWrapper";
// import useExportToPDF from "component/htmlToPDF/export-html-pdf";
import { useReactToPrint } from "react-to-print";
import MainButton from "component/shared/mainButton/MainButton";

const NewsDetailsContent = ({ newsDetailsFetching }) => {
  // const [exportToPDF] = useExportToPDF();
  const currentLocale = useSelector(({ theme }) => theme.locale);

  // const downloadAndReadImage = async (imageUrl) => {
  //   try {
  //     var splitArr = imageUrl.split("/");
  //     const imageGuid = splitArr[splitArr.length - 1].replaceAll(
  //       "?x-request=html",
  //       ""
  //     );
  //     const response = await fetch(
  //       `${END_POINTS.GET_PHOTO_BY_ID}?guid=${imageGuid}`
  //     );

  //     return response.data;
  //   } catch (error) {
  //     return null;
  //   }
  // };

  // const onExportPdfButton = async () => {
  //   const imagePromises = [];
  //   pdfRef.current.querySelectorAll("img").forEach((image) => {
  //     if (
  //       !image.src.includes("base64") &&
  //       image.className !== "capmas-internal-logo"
  //     ) {
  //       // Push the promise for each image processing into the array
  //       imagePromises.push(
  //         new Promise(async (resolve) => {
  //           const base64Img = await downloadAndReadImage(image.src);
  //           image.src = base64Img;
  //           resolve();
  //         })
  //       );
  //     }
  //   });

  //   await Promise.all(imagePromises);
  //   exportToPDF({
  //     ref: pdfRef,
  //     //allowLogo: !displayCuztomizedTemplate(),
  //     fileName: LabelLangString({
  //       currentLocale: currentLocale,
  //       id: "title",
  //       defaultValue: newsDetailsFetching?.data?.data?.title,
  //       translations: newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS],
  //     }),
  //   });
  // };

  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";

  const pdfRef = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: LabelLangString({
      currentLocale: currentLocale,
      id: "title",
      defaultValue: newsDetailsFetching?.data?.data?.title,
      translations: newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS],
    }),
    content: () => pdfRef.current,
    pageStyle: ``,
  });

  const displayCuztomizedTemplate = () => {
    if (
      !newsDetailsFetching?.data ||
      newsDetailsFetching?.isLoading ||
      newsDetailsFetching?.error
    )
      return false;

    const isDisplayCuztomizedTemplate = newsDetailsFetching?.data?.data[
      "newsCategory"
    ].filter(({ category }) => category.id === 1);
    return isDisplayCuztomizedTemplate.length > 0;
  };
  return (
    <div>
      <Row>
        <NewsCustomizedContentWrapper
          allowCustomization={displayCuztomizedTemplate()}
        >
          <Stack gap={3} className="content">
            {newsDetailsFetching?.data !== undefined &&
              newsDetailsFetching?.data?.data?.image !== "" &&
              newsDetailsFetching?.data?.data?.image !== null && (
                <img
                  className="content-img"
                  src={`${API_BASE_URL}${newsDetailsFetching?.data?.data?.image}?x-request=html`}
                  alt="content-item"
                  style={{ objectFit: "contain" }}
                />
              )}
            <label className="content-date">
              {newsDetailsFetching?.data === undefined ? (
                ""
              ) : (
                <DateFormater
                  value={newsDetailsFetching?.data?.data?.publishDate}
                />
              )}
            </label>
            <label className="content-title">
              {newsDetailsFetching?.data === undefined ? (
                ""
              ) : (
                <LabelLang
                  id="title"
                  defaultValue={newsDetailsFetching?.data?.data?.title}
                  translations={
                    newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS]
                  }
                />
              )}
            </label>
            <div className="content-details" style={{ overflowX: "hidden" }}>
              <HtmlView
                html={
                  newsDetailsFetching?.data === undefined ? (
                    <></>
                  ) : (
                    LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: newsDetailsFetching?.data?.data?.content,
                      translations:
                        newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS],
                    })
                  )
                }
              />
            </div>
          </Stack>
        </NewsCustomizedContentWrapper>

        <div className=" d-none">
          <NewsCustomizedContentWrapper
            allowCustomization={displayCuztomizedTemplate()}
          >
            <div ref={pdfRef} className="px-3">
              <img
                src={pdfHeader}
                alt="pdf-header"
                className="w-100"
                style={{
                  // position: "fixed",
                  top: "5px",
                  left: 1,
                  zIndex: 100000,
                }}
              />
              <Stack gap={3} className="news content my-5">
                {newsDetailsFetching?.data !== undefined &&
                  newsDetailsFetching?.data?.data?.image !== "" &&
                  newsDetailsFetching?.data?.data?.image !== null && (
                    <img
                      className="content-img"
                      src={`${API_BASE_URL}${newsDetailsFetching?.data?.data?.image}?x-request=html`}
                      alt="content-item"
                      style={{ objectFit: "contain" }}
                    />
                  )}
                <label className="content-date">
                  {newsDetailsFetching?.data === undefined ? (
                    ""
                  ) : (
                    <DateFormater
                      value={newsDetailsFetching?.data?.data?.publishDate}
                    />
                  )}
                </label>
                <label className="content-title">
                  {newsDetailsFetching?.data === undefined ? (
                    ""
                  ) : (
                    <LabelLang
                      id="title"
                      defaultValue={newsDetailsFetching?.data?.data?.title}
                      translations={
                        newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS]
                      }
                    />
                  )}
                </label>
                <div className="content-details">
                  <HtmlView
                    html={
                      newsDetailsFetching?.data === undefined ? (
                        <></>
                      ) : (
                        LabelLangString({
                          id: "content",
                          currentLocale: currentLocale,
                          defaultValue:
                            newsDetailsFetching?.data?.data?.content,
                          translations:
                            newsDetailsFetching?.data?.data[
                              TRANSLATION_KEYS.NEWS
                            ],
                        })
                      )
                    }
                  />
                </div>
              </Stack>
              <img
                src={pdfFooter}
                alt="pdf-footer"
                className="w-100"
                style={{
                  // position: "fixed",
                  bottom: "10px",
                  left: 1,
                  zIndex: 100000,
                }}
              />
            </div>
          </NewsCustomizedContentWrapper>
        </div>
      </Row>
      <Row>
        <Stack gap={3}>
          <Container className="mt-5">
            <Row>
              <Col item xs={12} sm={10} md={8} lg={6}>
                <Row className="d-flex justify-content-start align-items-center">
                  <Col item xs={4} md={3} className="p-0">
                    <label className="px-1 fw-bold fs-16">
                      <FormattedMessage id="share-news" />
                    </label>
                  </Col>
                  <Col>
                    <div className="d-flex gap-2">
                      <FacebookShare
                        url={`${window.location.href}`}
                        title={newsDetailsFetching?.data?.data?.title}
                        tags={newsDetailsFetching?.data?.data?.tags}
                      >
                        <div className="item-link">
                          <i className="icon fab fa-facebook-f"></i>
                        </div>
                      </FacebookShare>
                      <TwitterShare
                        url={`${window.location.href}`}
                        title={newsDetailsFetching?.data?.data?.title}
                        tags={newsDetailsFetching?.data?.data?.tags}
                      >
                        <img
                          className="img1"
                          src={process.env.PUBLIC_URL + "/image/X-small.png"}
                          height={32}
                          width={32}
                          content-item
                          loading="lazy"
                        />
                      </TwitterShare>
                      <LinkedinShare
                        url={`${window.location.href}`}
                        title={newsDetailsFetching?.data?.data?.title}
                        brief={newsDetailsFetching?.data?.data?.brief}
                      >
                        <div className="item-link">
                          <a href="">
                            <i className="icon fab fa-linkedin-in"></i>
                          </a>
                        </div>
                      </LinkedinShare>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="justify-content-start align-items-center"
                  style={{ marginTop: "1rem" }}
                >
                  <Col item xs={4} md={3} className="p-0">
                    <label className="px-1 fw-bold fs-16">
                      <FormattedMessage id="download-the-news" />
                    </label>
                  </Col>
                  <Col item xs={2} className="p-0">
                    <Button
                      className="p-0"
                      variant="outline"
                      // onClick={onExportPdfButton}
                      onClick={generateToPDF}
                    >
                      <img
                        fill="yellow"
                        className="p-0"
                        width={35}
                        height={35}
                        src={`${process.env.PUBLIC_URL}/icons/pdf-icon.png`}
                        alt={"pdf-icon"}
                        loading="lazy"
                      />
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col item xs={12} sm={12} md={6}>
                <div className="d-flex text-align-end justify-content-end flex-wrap">
                  {/* <span className="px-1 pb-2">
                    <MainButton link={""} text={"explore-data"} />
                  </span> */}
                  {newsDetailsFetching?.data?.data?.publicationId && (
                    <span className="px-1 pb-2">
                      <MainButton
                        link={`publications/${newsDetailsFetching?.data?.data?.publicationId}`}
                        text={"publication"}
                      />
                    </span>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </Stack>
      </Row>
    </div>
  );
};

export default NewsDetailsContent;
